<svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
<rect x="3.07667" y="3.07667" width="9.84667" height="9.84667" rx="0.923333" stroke="#93939F" stroke-width="0.82"/>
<path d="M7.2381 10.0346L5.33333 8.12983L5.93928 7.52381L7.2381 8.82255L10.061 6L10.6688 6.60415L7.2381 10.0346Z" fill="#93939F"/>
</svg>
